import { render, staticRenderFns } from "./Pay2CoinTransaction.vue?vue&type=template&id=c9e4e3ce"
import script from "./Pay2CoinTransaction.vue?vue&type=script&lang=js"
export * from "./Pay2CoinTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports